module.exports = function () {
    return function (dateValue) {
        const monthNames = new Array(
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December');

        const returnDate = dateValue.getDate();
        let sup = '';
        if (returnDate === 1 || returnDate === 21 || returnDate === 31) {
            sup = 'st';
        } else if (returnDate === 2 || returnDate === 22) {
            sup = 'nd';
        } else if (returnDate === 3 || returnDate === 23) {
            sup = 'rd';
        } else {
            sup = 'th';
        }

        return returnDate + sup + ' ' + monthNames[dateValue.getMonth()];

    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-format-date.js
 **/